import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

// common components
import { CommonModule } from '@angular/common';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { CustomPopupModalComponent } from '../common/custom-popup-modal/custom-popup-modal.component';
import { PreviewListingModule } from '../common/listing-preview/preview-listing.module';
import { NavTaskManagerComponent } from '../common/nav-task-manager/nav-task-manager.component';
import { ReorderPipeModule } from '../core/pipes/reorder-pipe/reorder.module';
import { ProjectAppointmentCreateComponent } from '../modules/my-projects/edit-project/project-edit/project-appointment/project-appointment-create/project-appointment-create.component';
import { ProjectAppointmentListComponent } from '../modules/my-projects/edit-project/project-edit/project-appointment/project-appointment-list/project-appointment-list.component';
import { MenuModule } from '../modules/my-tasks/menu/menu.module';
import { AddRoleComponent } from '../modules/setting/manage-user-contacts/roles/add-role/add-role.component';
import { EditRoleComponent } from '../modules/setting/manage-user-contacts/roles/edit-role/edit-role.component';
import { CentralizedModuleProcessesComponent } from '../modules/workflow/centralized-module-processes/centralized-module-processes.component';
import { FlowMainComponent } from '../modules/workflow/flow-main/flow-main.component';
import { FlowTriggerComponent } from '../modules/workflow/flow-trigger/flow-trigger.component';
import { LeftFlowComponent } from '../modules/workflow/left-flow/left-flow.component';
import { WorkflowProcessesComponent } from '../modules/workflow/workflow-processes/workflow-processes.component';
import { LeadBookingPublicComponent } from '../public-page/lead-booking-public/lead-booking-public.component';
import { ListingPreviewStaticComponent } from '../public-page/listing-preview-static/listing-preview-static.component';
import { CommonSharedModule } from './common-shared.module';
import { FirmwareCommonModule } from './firmware-common.module';
import { PipeDirectiveModule } from './pipe-directive.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { RecordCountComponent } from '@common/record-count/record-count.component';
import { PossibleDuplicateContactModule } from '@modules/contact/possible-duplicate-contact/possible-duplicate-contact.module';
import { RemmiDateRangeModule } from '@common/remmi-date-range/data-range.module';
import { MyBookingLinkComponent } from '../modules/my-projects/edit-project/project-edit/project-external-calendar/my-booking-link/my-booking-link.component';

const ComponentList = [
  ListingPreviewStaticComponent,
  LeadBookingPublicComponent,
  ProjectAppointmentCreateComponent,
  ProjectAppointmentListComponent,
  NavTaskManagerComponent,
  FlowMainComponent,
  WorkflowProcessesComponent,
  LeftFlowComponent,
  FlowTriggerComponent,
  CentralizedModuleProcessesComponent,
  CustomPopupModalComponent,
  AddRoleComponent,
  EditRoleComponent,
];

@NgModule({
  declarations: [...ComponentList],
  imports: [
    RecordCountComponent,
    CommonModule,
    FirmwareCommonModule,
    PipeDirectiveModule,
    CommonSharedModule,
    MenuModule,
    PreviewListingModule,
    ReorderPipeModule,
    ReMultipleSelectModule,
    ReMultiselectModule,
    FullCalendarModule,
    PossibleDuplicateContactModule,
    RemmiDateRangeModule,
    MyBookingLinkComponent,
  ],
  exports: [...ComponentList, FirmwareCommonModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
